<template>
  <Teleport to="body">
    <!-- Backdrop -->
    <transition name="modal-fade">
      <div
        v-show="modelValue"
        class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[150] p-4"
        @click.self="close"></div>
    </transition>

    <!-- Modal Card -->
    <transition name="modal-scale">
      <div v-show="modelValue" class="fixed inset-0 flex items-center justify-center z-[151] p-4 pointer-events-none">
        <div
          class="pointer-events-auto w-full max-w-sm rounded-2xl border border-gray-200 bg-white p-6 shadow-xl dark:border-gray-700 dark:bg-gray-800 max-h-[90vh] overflow-y-auto">
          <!-- Header -->
          <div class="flex items-center justify-between mb-5">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">{{ tt('Settings', 'Nastavitve') }}</h3>
            <button
              @click="close"
              class="flex items-center justify-center w-8 h-8 rounded-lg text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-600 dark:hover:text-gray-200 transition-colors">
              <span class="material-symbols-outlined">close</span>
            </button>
          </div>

          <!-- Shared settings body (also the App Settings subpage). -->
          <AppSettingsPanel :active="modelValue" @enter-touch-mode="enterTouchMode" />

          <!-- Close button -->
          <button
            @click="close"
            class="mt-5 w-full py-2.5 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 rounded-full font-medium text-sm hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
            {{ tt('Done', 'Končano') }}
          </button>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import AppSettingsPanel from './AppSettingsPanel.vue';
import { tt } from '../../utils/consoleText';

defineProps<{
  modelValue: boolean;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
  enterTouchMode: [];
}>();

const router = useRouter();

function close() {
  emit('update:modelValue', false);
}

function enterTouchMode() {
  close();
  router.push('/pair');
}
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-scale-enter-active {
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}
.modal-scale-leave-active {
  transition:
    opacity 0.15s ease,
    transform 0.15s ease;
}
.modal-scale-enter-from {
  opacity: 0;
  transform: scale(0.95);
}
.modal-scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>
